import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
    selector: 'odq-general-error',
    templateUrl: './general-error.component.html',
    styleUrls: ['./general-error.component.scss'],
    standalone: false
})
export class GeneralErrorComponent implements OnInit {
  routeParams: Params;
  isIE = false;

  constructor(private location: Location, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.isIE = /msie\s|trident/i.test(window.navigator.userAgent);

    this.activatedRoute.queryParams.subscribe( params => {
      this.routeParams = params;

      const replaceUrl = params.replaceUrl || undefined;
      if (replaceUrl) {
        this.location.replaceState(replaceUrl);
      }
    });
  }

}
